/**
 * This function can be used to filter out null and undefined values from an array with type guard safety.
 * https://stackoverflow.com/questions/43118692/typescript-filter-out-nulls-from-an-array
 */
export default function notNullOrUndefined<T>(value: T | null | undefined): value is T {
  if (value === null || value === undefined) return false;

  return true;
}
